module.exports = __webpack_public_path__ + "static/media/mockup2-opt.b538c66a.gif";